import React from 'react';
import { marked } from 'marked';
import escapeHtml from 'escape-html';

interface MarkdownProps {
  content: string;
  className?: string;
}

/*
 * From docs (https://marked.js.org/):
 * ⚠️ Input: special ZERO WIDTH unicode characters (for example \uFEFF) might interfere with parsing.
 * Some text editors add them at the start of the file (see: https://github.com/markedjs/marked/issues/2139).
 * */
const removeZeroWidth = (contents: string) =>
  `${contents}`.replace(/^[\u200B\u200C\u200D\u200E\u200F\uFEFF]/, '');

export function Markdown({ content, className = '' }: MarkdownProps) {
  // Configure marked to handle line breaks
  marked.setOptions({
    breaks: true,
  });

  // Parse markdown to HTML
  const html = marked(escapeHtml(removeZeroWidth(content)));

  return (
    <div
      className={`prose prose-sm max-w-none ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
